import { faUserDoctorHair } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { handleClick } from './helper';
import NavLink from './NavLink';
import * as styles from './styles.module.scss';

const DoctorInfo = ({
  isActive,
  setActive,
  dataLinkId,
}: {
  isActive?: boolean;
  setActive?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  dataLinkId: string;
}) => {
  const iconLinkContainerClasses = `${styles.LeftNavIconLinkContainer} ${styles.IconLinkContainer}`;

  const doctorInfoLinkClassname = `${styles.LinkRight} ${styles.DoctorLink} ${
    isActive ? styles.Active : ''
  }`;

  const onClick = (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    handleClick(ev, setActive);
  };

  const iconClass = `${styles.Icon} ${isActive ? styles.Active : ''}`;

  return (
    <NavLink
      dataLinkId={dataLinkId}
      icon={faUserDoctorHair}
      iconClassName={iconClass}
      iconContainerClassName={iconLinkContainerClasses}
      textClassName={doctorInfoLinkClassname}
      copy="Doctor Info"
      onClick={onClick}
    />
  );
};

export default DoctorInfo;
